<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="hasError">
  <h2 class="warning">
    возникла ошибка при загрузке заказа

  </h2>
  <button mat-raised-button (click)="reload()">
    <mat-icon>refresh</mat-icon> обновить
  </button>
</div>

<div *ngIf="refundInfo" class="">
  <h1 class="refund-warning"> Возврат {{refundInfo.number}} от {{refundInfo.date | date:'dd.MM.yyyy HH:mm'}}</h1>
  <span *ngIf="refundInfo.isPickup" class="pickup air">самовывоз</span>
  <br><br>

  <span *ngIf="buypoint; else ttNotFound">
    {{buypoint.name}}

    <!-- <button *ngIf="buypoint.isOwn" mat-icon-button [routerLink]="['/ors',buypoint.id]" color="primary" class="icon"> -->
    <mat-icon *ngIf="buypoint.isOwn" mat-icon-button [routerLink]="['/ors',buypoint.id]" color="primary"
      class="icon">link</mat-icon>
    <!-- </button> -->

    <!-- <button *ngIf="!buypoint.isOwn" mat-icon-button [routerLink]="['/client',buypoint.id]" color="primary" class="icon"> -->
    <mat-icon *ngIf="!buypoint.isOwn" mat-icon-button [routerLink]="['/client',buypoint.id]" color="primary"
      class="icon">link</mat-icon>
    <!-- </button> -->

  </span>

  <span *ngIf="refundInfo.firm"> <br> <span class="primary">Организация: </span> {{refundInfo.firm}} </span>
  <br>
  <span class="primary">Сумма: </span>
  {{refundInfo.summa | currency:'RUB':'symbol':'1.2-2':'ru'}} <span class="warn"
    *ngIf="refundInfo.summa1C !== refundInfo.summa"> (1с: {{refundInfo.summa1C | currency:'RUB':'symbol':'1.2-2':'ru'}})
  </span>
  <br>
  <span class="primary" *ngIf="refundInfo.dateDelivery">Возврат на </span> {{refundInfo.dateDelivery | date:
  'dd.LL.yyyy'}}
  <span class="primary" *ngIf="refundInfo.deliveryComment"> ({{refundInfo.deliveryComment}}) </span>


  <span *ngIf="refundInfo.note">Коментарий:
    <span class="primary">({{refundInfo.note}})</span>
  </span>
  <span class="warn" *ngIf="refundInfo.error "><br>Ошибка: {{refundInfo.error}} </span>

  {{refundInfo.isWebbed ? " web " : ""}}
  {{refundInfo.is1Ced ? " 1c " : ""}}



  <ng-container *ngIf="refundInfo.orders1c?.length ">
    <br>
    <ng-container *ngIf="preOrder">
      <mat-chip-listbox [(ngModel)]="preOrder.id" selectable="false" hideSingleSelectionIndicator="true">
        <mat-chip-option *ngIf="!check1cItems()" color="accent" [value]="refundInfo.id" (click)="preOrder = refundInfo">
          <app-order-status-indicator style="display: inline-block; background-color: white; border-radius: 50%;"
            [statusId]="refundInfo.statusId" [onlyIcon]="true"></app-order-status-indicator>
          {{refundInfo.number}}</mat-chip-option>

        <mat-chip-option *ngFor="let preord of refundInfo.orders1c;" (click)="preOrder = newPreord(preord)"
          [value]="preord.id">
          <app-order-status-indicator style="display: inline-block; background-color: white; border-radius: 50%;"
            [statusId]="preord.statusId" [onlyIcon]="true"></app-order-status-indicator>
          {{preord.number}}
        </mat-chip-option>

      </mat-chip-listbox>

    </ng-container>
    <div *ngIf="!orderMain() && preOrder">
      <!-- <app-order-status-indicator style="display: inline-block;"
        [statusId]="preOrder.statusId"></app-order-status-indicator> -->
      <div *ngIf="preOrder?.firm"> <span class="primary"> Организация: </span>
        {{preOrder.firm}} <br></div>
      <strong *ngIf="preOrder?.dateDelivery"><span class="primary">Доставка </span>
        {{preOrder.dateDelivery
        | date:'dd.LL.yyyy'}}</strong>

      <div *ngIf="preOrder?.note" style="color: darkorange;">Коментарий: {{preOrder.note}}</div>
      <!--  class="warn" -->
      <div *ngIf="preOrder?.error" class="warn"><br>Ошибка: {{preOrder.error}}</div>
    </div>

  </ng-container>



  <ng-template #ttNotFound>
    {{refundInfo.buypoint}}
  </ng-template>

  <hr>

  <div *ngIf="preOrder">
    <app-order-info-table [(orderInfo)]="preOrder" [main]="orderMain()" mode="refund">
      <!-- [main]="orderInfo.id === preOrder.id" -->
    </app-order-info-table>
  </div>